import { render, staticRenderFns } from "./ExpiryCell.vue?vue&type=template&id=67871a0c&scoped=true"
import script from "./ExpiryCell.vue?vue&type=script&lang=js"
export * from "./ExpiryCell.vue?vue&type=script&lang=js"
import style0 from "./ExpiryCell.vue?vue&type=style&index=0&id=67871a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67871a0c",
  null
  
)

export default component.exports